"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _types = require("../types");
var _chime = require("@studio/chime");
var _constants = require("@studio/constants");
var _selectors = require("../../selectors");
var _index = require("./index");
var _source = require("../source");
var _feature = require("@studio/feature.flags");
/**
 * @param {*} attendeeId
 * @param {*} presence
 * @param {*} disconnectSource
 * @returns
 */
function setAttendeePresence(attendeeId, presence, disconnectSource) {
  return function (dispatch, getState) {
    var state = getState();
    var _state$meeting = state.meeting,
      meetingSession = _state$meeting.meetingSession,
      attendeeResponse = _state$meeting.attendeeResponse,
      attendeePresence = state.attendeePresence;
    var attendeePresent = attendeePresence.includes(attendeeId);
    var sources = (0, _selectors.selectBroadcastSources)(state);
    var action = {
      type: _types.BROADCAST_SET_ATTENDEE_PRESENCE,
      payload: {
        attendeeId: attendeeId,
        presence: presence
      }
    };
    var useAgora = (0, _feature.shouldHaveFeature)('studio.meetingVendor') === _constants.VENDOR_AGORA;
    (0, _reactRedux.batch)(function () {
      if (attendeeSourceExists(sources, attendeeId)) {
        if (presence) {
          var localAttendeeId = attendeeResponse && attendeeResponse.Attendee.AttendeeId;
          // Only execute for other presenters and not screen share sources
          if (localAttendeeId !== attendeeId && !attendeeId.includes('#content') && !useAgora) {
            var isAttendeeCameraOn = (0, _chime.haveVideoTileForAttendeeId)(meetingSession, attendeeId);
            dispatch((0, _index.setAttendeeCameraStatus)(attendeeId, isAttendeeCameraOn));
          }
          // If they are present, and they have a source, cancel the disconnect
          forEachAttendeeSource(attendeeId, sources, function (s) {
            dispatch((0, _source.cancelDisconnectSource)(s._id));
          });
          // We only want to fetch all sources when a new user joins, if attendee is already present skip.
          if (!attendeePresent) {
            dispatch((0, _source.getSources)());
          }
        } else {
          forEachAttendeeSource(attendeeId, sources, function (s) {
            dispatch((0, _source.queueDisconnectSource)(s._id, 1, disconnectSource));
          });
        }
      }
      dispatch(action);
    });
  };
}
function isExistingAttendee(s, attendeeId) {
  return s.type === _constants.CAMERA_PRESENTER && s.value === attendeeId;
}
function forEachAttendeeSource(attendeeId, sources, cb) {
  sources.filter(function (s) {
    return isExistingAttendee(s, attendeeId);
  }).forEach(cb);
}
function attendeeSourceExists(sources, attendeeId) {
  return !!sources.find(function (s) {
    return isExistingAttendee(s, attendeeId);
  });
}
var _default = exports["default"] = setAttendeePresence;